import React, { PureComponent } from 'react';
import { Map } from 'immutable';
import PropTypes from 'prop-types';

import LocationApplicationForm from 'features/hiring/ApplicationForm/LocationApplicationForm';

import Box from 'components/Box';
import Text, { BigDetail } from 'components/Text';

import cxHelpers from 'util/className';

import ApplyLink from '../ApplyLink';

@cxHelpers('LocationProfileRow')
export default class LocationProfileRow extends PureComponent {
  static propTypes = {
    locationProfile: PropTypes.instanceOf(Map).isRequired,
  };

  state = {
    showApplicationForm: false,
  };

  handleClick = () => {
    this.setState({ showApplicationForm: !this.state.showApplicationForm });
  };

  renderRow = () => (
    <Box spacebetween>
      <Box>
        <Box mbxxxs>
          <Text i18n="hiring.company_profile.dont_see_job" />
        </Box>
        <BigDetail i18n="hiring.company_profile.apply_anyway" />
      </Box>

      <ApplyLink
        className={this.cxEl('apply-link')}
        applyLink={this.props.locationProfile.get('apply_link')}
        onToggleApplicationForm={this.handleClick}
        showApplicationForm={this.state.showApplicationForm}
      />
    </Box>
  );

  render() {
    const { showApplicationForm } = this.state;

    return (
      <Box>
        {!showApplicationForm && (
          <Box phm>
            <hr />
          </Box>
        )}

        <Box
          pam
          mbxxl
          className={this.cx()}
          bradius={3}
          b={showApplicationForm && 'grayMedium'}
          bg={showApplicationForm && 'white'}
        >
          {this.renderRow()}

          {showApplicationForm && (
            <Box pal>
              <LocationApplicationForm
                locationProfileUrl={this.props.locationProfile.get('url')}
                locationCountryCode={this.props.locationProfile.get(
                  'country_code'
                )}
              />
            </Box>
          )}
        </Box>
      </Box>
    );
  }
}
